import { render, staticRenderFns } from "./RouteTab.vue?vue&type=template&id=484c434e&"
import script from "./RouteTab.vue?vue&type=script&lang=js&"
export * from "./RouteTab.vue?vue&type=script&lang=js&"
import style0 from "./RouteTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports